<template>
  <b-modal v-if="users" v-model="active" :title="title" centered size="md" :hide-footer="!footer">
    <h-f-global-search-field
      v-model="searchUsers"
      :base-url="userUrl"
      fields="uuid,first_name,last_name"
      placeholder="Rechercher des utilisateurs"
      ressource="users"
      style="position: relative; z-index: 1000"
    ></h-f-global-search-field>
    <div class="user-container-search">
      <div
        v-for="(user, index) in searchUsersFormated"
        :key="index"
        class="d-flex justify-content-between align-items-center mb-2"
      >
        <h-e-profile-default :first-name="user.first_name" :last-name="user.last_name" size="sm"></h-e-profile-default>
        <div>{{ user.first_name }} {{ user.last_name }}</div>
        <i class="mdi mdi-plus-circle-outline text-primary cursor-pointer" @click="addUser(index)"></i>
      </div>
    </div>
    <h5 class="mt-3">Utilisateurs associés :</h5>
    <div class="mt-3 px-4">
      <div
        v-for="(user, index) in formatedUsers"
        :key="index"
        class="d-flex justify-content-between align-items-center mb-2"
      >
        <h-e-profile-default :first-name="user.firstName" :last-name="user.lastName" size="sm"></h-e-profile-default>
        <div>{{ user.firstName }} {{ user.lastName }}</div>
        <i class="mdi mdi-close text-primary cursor-pointer" @click="removeUser(index)"></i>
      </div>
    </div>
    <template v-slot:modal-footer v-if="footer">
      <div class="d-flex justify-content-end">
        <h-b-action text="Valider" :positive="true" @click.native="handleConfirm"></h-b-action>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { APIRequest, FunctionHelpers } from '@/node-sdk'

export default {
  name: 'user',

  props: {
    value: Array,
    title: {
      type: String,
      required: true,
    },
    limitToUsers: {
      type: Array,
      default: () => [],
    },
    footer: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      users: [],
      active: false,
      userUrl: process.env.VUE_APP_API,
      searchUsers: [],
      assignedUsers: this.value,
      searchUsersFormated: [],
      formatedUsers: [],
    }
  },

  watch: {
    searchUsers: function () {
      this.formatSearchUsers()
    },

    value: async function () {
      this.assignedUsers = this.value
      this.formatAssignedUsers()
    },

    active: function () {
      if (!this.active) {
        this.$emit('close')
      }
    },
  },

  async mounted() {
    await this.getUsers()
  },

  methods: {
    manageUserPop() {
      this.active = !this.active
    },

    async getUsers() {
      this.users = await APIRequest.get_with_request(process.env.VUE_APP_API, 'users', '')
      this.users = this.users[0]
      this.formatAssignedUsers()
    },

    formatAssignedUsers() {
      this.formatedUsers = []
      this.formatedUsers = FunctionHelpers.formatUsers(this.users, this.assignedUsers)
    },

    formatSearchUsers() {
      this.searchUsersFormated = []
      let users = FunctionHelpers.formatSearchArray(this.searchUsers, this.formatedUsers, 'uuid', 'id')
      if (this.limitToUsers.length !== 0) {
        for (let i = 0; i < users.length; i++) {
          if (this.limitToUsers.find((user) => user === users[i].uuid)) {
            this.searchUsersFormated.push(users[i])
          }
        }
      } else {
        this.searchUsersFormated = users
      }
    },

    addUser(index) {
      this.assignedUsers.push(this.searchUsersFormated[index].uuid)
      this.$emit('input', this.assignedUsers)
      this.$emit('add', this.searchUsersFormated[index].uuid)
      this.formatAssignedUsers()
      this.$delete(this.searchUsersFormated, index)
    },

    removeUser(index) {
      let assignedUserIndex = this.assignedUsers.findIndex((user) => user === this.formatedUsers[index].id)
      this.$delete(this.assignedUsers, assignedUserIndex)
      this.$emit('input', this.assignedUsers)
      this.searchUsersFormated.push(this.users.find((user) => user.uuid === this.formatedUsers[index].id))
      this.$delete(this.formatedUsers, index)
    },

    handleConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style scoped>
.user-container-search {
  max-height: 200px;
  overflow: scroll;
  padding: 40px 30px 20px 30px;
  transform: translateY(-20px);
  display: block;
  z-index: 500;
  border-radius: 0 0 20px 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>
